// extracted by mini-css-extract-plugin
export default {"autocompleteContainer":"SupplierPalletsTransferHistoryFiltersModal_autocompleteContainer__3rgDD"};